import en from '@/locales/en.json'
import vi from '@/locales/vi.json'
import zh from '@/locales/zh.json'
import ko from '@/locales/ko.json'
import ru from '@/locales/ru.json'
import { LanguageCode } from '~/data/language'

const dictionaries: Record<string, any> = {
  en,
  vi,
  zh,
  ko,
  ru,
}

export function getTranslation(locale?: string) {
  const dict = locale ? dictionaries[locale] : dictionaries.vi
  return function t(path: string, params?: Record<string, string | number>): string {
    const raw = path.split('.').reduce((obj, key) => obj?.[key], dict) || path
    if (!params) return raw
    return Object.entries(params).reduce(
      (str, [key, value]) => str.replaceAll(`{{${key}}}`, String(value)),
      raw
    )
  }
}

export function getDictionary(locale: string) {
  return dictionaries[locale] || dictionaries.en
}

export const getLocalizedHref = (
  href: string,
  locale: LanguageCode,
  defaultLocale: LanguageCode = LanguageCode.VI
) => {
  if (!href) return href

  const hasLocalePrefix = Object.values(LanguageCode).some((code) => href.startsWith(`/${code}/`))

  if (hasLocalePrefix) {
    const segments = href.split('/')
    segments[1] = locale
    return segments.join('/')
  }

  return locale === defaultLocale ? href : `/${locale}${href}`
}
